import { InjectionToken } from '@angular/core';

/**
 * @description Removes HTML tags from a given string.
 *              Example Input: "<p>This string has <strong>tags</strong>, some <i>even <u>nested</u></i>!</p>"
 *              Example Output: "This string has tags, some even nested!"
 * @param str   the string to convert
 */
export const stripHtmlTagsFromString = (str: string): string =>
    str.replace(/(<([^>]+)>)/ig, '');

export type StripHTMLTagsFromStringProvider = (str: string) => string;
export const STRIP_HTML_TAGS_FROM_STRING =
    new InjectionToken('STRIP_HTML_TAGS_FROM_STRING', {
        factory: () => stripHtmlTagsFromString
    });
